import { render, staticRenderFns } from "./mobileHeader.vue?vue&type=template&id=06228bfc&"
import script from "./mobileHeader.vue?vue&type=script&lang=js&"
export * from "./mobileHeader.vue?vue&type=script&lang=js&"
import style0 from "./mobileHeader.vue?vue&type=style&index=0&id=06228bfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports